export class SalesPhase{
    SalesPhaseID : number;
    SalesPhaseName : string;
    SalesPhaseDescription : string;
    IsActive : boolean = true;
    ModifiedBy : number;
}